import classNames from 'classnames';
import React, { useEffect } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { compose } from 'redux';
import { getPreviewAssessmentDetailsSelector, getPreviewAssessmentIdSelector } from '@redux/tasks/tasksSelector';
import { clearPreviewAssessmentDetailsThunk, getAssessmentResultThunk, getPreviewAssessmentDetailsThunk } from '@redux/tasks/tasksThunks';
import { AssessmentResultType } from '@redux/tasks/tasksTypes';
import { ReduxState } from '@redux/types';
import { BackIconButton } from 'components/Button/BackButton/BackIconButton';
import { CloseIconButton } from 'components/Button/CloseButton/CloseIconButton';
import { Text } from 'components/Typography';
import { Color } from 'utils/color';
import style from './TaskPreviewArea.scss';

type CustomProps = {
  onClose: () => void;
  onBack: () => void;
  containerStyle?: string;
  previewResultId?: string;
};

type Props = ConnectedProps<typeof connectRedux> & CustomProps;

const TaskPreviewArea: React.FC<Props> = ({
  onClose,
  onBack,
  containerStyle,
  previewResultId,
  previewId,
  getPreviewDetails,
  getPreviewResultDetails,
  previewDetails,
  clearPreviewDetails
}) => {
  useEffect(() => {
    previewId && getPreviewDetails(previewId);

    return () => {
      previewId && clearPreviewDetails();
    };
  }, []);

  useEffect(() => {
    previewResultId && getPreviewResultDetails(previewResultId);

    return () => {
      previewResultId && clearPreviewDetails();
    };
  }, []);

  return (
    <div className={classNames(style.container, containerStyle)}>
      <CloseIconButton containerClassName={style.closeButton} onClick={onClose} />
      <BackIconButton containerClassName={style.backButton} onClick={onBack} />
      <Text variant="h5" weight={500} className={style.title}>
        {previewDetails?.name}
      </Text>
      {(previewDetails as AssessmentResultType)?.result && (
        <div className={style.resultWrapper}>
          <Text variant="md">{'Result:\n'}</Text>
          <Text variant="md" color={Color.GRAY}>
            {(previewDetails as AssessmentResultType).result}
          </Text>
        </div>
      )}
      {previewDetails?.questions?.map((item) => (
        <div className={style.questionWrapper} key={item.question}>
          <Text variant="sm" color={Color.GRAY}>
            {item.question}
          </Text>
          <div className={style.optionsWrapper}>
            {item?.answer ? (
              <Text variant="sm" color={Color.GRAY_600}>
                {item.answer}
              </Text>
            ) : (
              <Text variant="sm" color={Color.GRAY_600}>
                &mdash;
              </Text>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

const connectRedux = connect(
  (state: ReduxState) => ({
    previewId: getPreviewAssessmentIdSelector(state),
    previewDetails: getPreviewAssessmentDetailsSelector(state)
  }),
  {
    getPreviewDetails: getPreviewAssessmentDetailsThunk,
    getPreviewResultDetails: getAssessmentResultThunk,
    clearPreviewDetails: clearPreviewAssessmentDetailsThunk
  }
);

export default compose(connectRedux)(TaskPreviewArea);
